import {Grid, Box} from '@primer/react-brand/esm'
import type {ReactNode} from 'react'
import baseStyles from '../../../styles/base.module.css'

function SupportGridRoot({children}: {children: ReactNode}) {
  return (
    <Grid columnGap="none" rowGap="none" enableGutters={false}>
      <Grid.Column span={{xsmall: 12, medium: 10, xlarge: 12}} start={{medium: 2}}>
        <Box
          className={`${baseStyles.narrowStackFrame} ${baseStyles.supportGridFrame}`}
          borderColor="muted"
          borderStyle="solid"
        >
          <Grid columnGap="none" rowGap="none" enableGutters={false}>
            {children}
          </Grid>
        </Box>
      </Grid.Column>
    </Grid>
  )
}

function SupportGridItem({children, index, total}: {children: ReactNode; index: number; total: number}) {
  const isMiddle = index > 0 && index < total - 1

  return (
    <Grid.Column
      span={{xsmall: 12, xlarge: 4}}
      // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
      className="gridColumn"
    >
      <Box
        padding={{narrow: 24, regular: 40, wide: 64}}
        paddingInlineStart={{narrow: 24, regular: 80, wide: 64}}
        paddingInlineEnd={{narrow: 24, regular: 80, wide: 64}}
        borderColor="muted"
        borderStyle="solid"
        className={`${baseStyles.stackedCardGridItem} ${isMiddle ? baseStyles.supportGridMiddleItem : ''}`}
        style={{height: '100%'}}
      >
        {children}
      </Box>
    </Grid.Column>
  )
}

export const SupportGrid = Object.assign(SupportGridRoot, {Item: SupportGridItem})
